(function ($) {
	var apiRoot = 'https://peoplespowerstation.org';

	$(document).ready(function () {
		const $maps = $('.embedded-map');

		if (!$maps.length) {
			return;
		}

		$maps.each(function () {
			const $map = $(this);

			setUpMap($map);

			if ($map.is('[data-installation-id]')) {
				buildPPSMap($map);
			} else {
				buildMap($map);
			}
		});
	});

	function setUpMap($map) {
		if (typeof window.maps === 'undefined') {
			window.maps = {};
		}

		const mapId = $map.attr('id');
		const coords = $map[0].dataset.coords.split(',');

		window.maps[mapId] = L.map(mapId).setView(coords, 16);
		window.maps[mapId].scrollWheelZoom.disable();

		L.tileLayer(
			'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_3wnc_1_2147934920dab5708cf3ba66',
			{
				attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>',
			},
		).addTo(window.maps[mapId]);
	}

	function buildMap($map) {
		const id = $map.attr('id');
		const coords = $map[0].dataset.coords.split(',');

		var dot = L.icon({
			iconUrl: window.pinUrl,
			iconSize: [16, 16],
			iconAnchor: [8, 8],
		});

		window.maps[id].panTo(coords);

		L.marker(coords, { icon: dot }).addTo(window.maps[id]);
	}

	function buildPPSMap($map) {
		const id = $map.attr('id');
		const installationId = $map[0].dataset.installationId;

		$.getJSON(`${apiRoot}/api/installations/id/${installationId}`, function (installation) {
			const coords = [installation.lat, installation.lng];

			window.maps[id].panTo(coords);

			var dot = L.icon({
				iconUrl: window.pinUrl,
				iconSize: [16, 16],
				iconAnchor: [8, 8],
			});

			L.marker(coords, { icon: dot })
				.bindPopup(mapPopupHTML(installation))
				.addTo(window.maps[id])
				.openPopup();
		});
	}

	// copied over from PPS and modified to fit in
	function mapPopupHTML(installation) {
		var EFFICIENCY_TYPES = {
			KNOWN: [
				'Efficient appliances',
				'Energy audit',
				'Improved Boiler',
				'Improved heating controls',
				'Insulation',
				'LED lighting',
				'User efficiencies',
			],
			AVAILABLE: [],
		};

		const cleanNumbers = {
			name: installation.name,
			owner: installation.owner,
			capacity: inWatts(installation.capacity),
			annualPredictedGeneration: inWatts(installation.annualPredictedGeneration, false, 'h'),
		};

		if (installation.datetime) {
			// cleanNumbers.datetime = moment(installation.datetime).fromNow();
		}

		const isRenewable = installation.type === 'Renewable Energy';
		const label = isRenewable
			? `${installation.type} installation`
			: `${installation.type} project`;

		const energyTypeClassName = installation.energyType
			? slug(installation.energyType).toLowerCase()
			: '';
		const typeClassName = slug(installation.type).toLowerCase();

		let supportedBy = '';

		if (installation.supportedBy && installation.supportedBy.length) {
			supportedBy = `<p><br>Supported by
        ${installation.supportedBy.join(',')}</p>`;
		}

		const htmlHead = `
      <article class="map-popup map-popup--${energyTypeClassName} map-popup--${typeClassName}">
        <div class="map-popup__label">${label}</div>
        <h1 class="map-popup__name">${installation.name}</h1>`;

		const htmlFoot = `
        <p>
          Owned by:<br>
          ${installation.owner}.
        </p>
        ${supportedBy}
        <p>
        <a href="${apiRoot}/installation/${installation.name}" target="_blank" rel="noopener noreferrer">
          View on People's Power Station
          <svg class="footer-social-icon"><use xlink:href="${window.assetsUrl}/assets/images/icons.svg' ?>#new-window"></use></svg>
        </a>
        </p>
      </article>`;

		let content = '';

		if (isRenewable) {
			content = `
        <div class="map-popup__icon-section">
          <div class="map-popup__icon-type">${installation.energyType}</div>
          <div class="map-popup__icon"></div>
        </div>

        <div class="map-popup__stat">
          <div class="map-popup__stat__number">${cleanNumbers.capacity}</div>
          Installed Capacity
        </div>

        <div class="map-popup__stat">
          <div class="map-popup__stat__number">${cleanNumbers.annualPredictedGeneration}</div>
          Annual predicted generation
        </div>`;
		} else {
			try {
				cleanNumbers.annualPredictedGeneration = inWatts(
					installation.interventions.total,
					false,
					'h',
				);
			} catch (e) {
				cleanNumbers.annualPredictedGeneration = inWatts(0, false, 'h');
			}
			// efficiency type
			const contentArr = [
				'<p>Implemented efficiency measures:</p>',
				'<div class="map-popup__efficiency">',
			];

			EFFICIENCY_TYPES.KNOWN.forEach((type) => {
				let extraClass = ' map-popup__efficiency__off';

				if (installation.interventions[type] > 0) {
					extraClass = '';
				}

				contentArr.push(
					`<div class="map-popup__efficiency--${slug(
						type,
					).toLowerCase()} ${extraClass}">${type}</div>`,
				);
			});

			contentArr.push(`</div>`);
			// efficiency type end

			if (installation.interventions.total) {
				contentArr.push(`
          <div class="map-popup__stat">
            <div class="map-popup__stat__number">${cleanNumbers.annualPredictedGeneration}</div>
            Annual predicted saving
          </div>`);
			}

			content = contentArr.join('');
		}

		const html = htmlHead + content + htmlFoot;

		return html;
	}

	function inWatts(watt, forcedUnit = false, hours = '', wrapUnits = true) {
		let unit = 'W';
		let decimalPlaces = 1;
		let returnWatt = watt;

		let divisor = 1;

		if (hours === '') {
			// capacity
			if (watt >= 1000000000) {
				divisor = 1000000000;
				unit = 'GW';
			} else if (watt >= 1000000) {
				divisor = 1000000;
				unit = 'MW';
			} else if (watt >= 1000) {
				divisor = 1000;
				unit = 'kW';
			}
		} else if (!forcedUnit) {
			// genertation kWh
			// always shows in kWh unless it is over 1,000,000,000W
			if (watt >= 1000000000) {
				divisor = 1000000000;
				unit = 'GW';
			} else {
				divisor = 1000;
				unit = 'kW';
			}
		}

		returnWatt = watt / divisor;

		if (returnWatt > 9 || unit === 'W') {
			decimalPlaces = 0;
		}

		let cleanWatt = prettyNumber(returnWatt, decimalPlaces);

		if (decimalPlaces && cleanWatt.endsWith('.0')) {
			cleanWatt = prettyNumber(returnWatt, 0);
		}

		if (wrapUnits) {
			return `${cleanWatt}<span class="units">${unit}${hours}</span>`;
		} else {
			return `${cleanWatt}${unit}${hours}`;
		}
	}

	function slug(name) {
		return name;
	}

	function prettyNumber(x) {
		return x.toLocaleString();
	}
})(jQuery);
